<div class="app-page-title">
    <div class="page-title-wrapper">
    <div class="page-title-heading">
    <div class="page-title-icon">
    <i class="pe-7s-phone icon-gradient bg-premium-dark"></i>
    </div>
    <div>Finances
    <div class="page-title-subheading">Gestion des finances</div>
    </div>
    </div>
    <div class="page-title-actions">
      <a routerLink="/transferts" type="button" class="btn btn-success text-white px-5 rounded-0">Transferts</a>
      <a routerLink="/deposits" type="button" class="btn btn-primary text-white px-5 rounded-0">Dépôt</a>
      <a  routerLink="/withdrawals" type="button" class="btn btn-danger text-white px-5 rounded-0">Retraits</a>
    </div>
  
  </div>
    </div>
    <div class="text-center">
      <app-loading [isVisible]="loading"></app-loading>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 mb-3" *ngFor="let d of data;let i=index">
          <div class="card card-body {{i%2==0 ? 'bg-info':'bg-success'}} text-white text-center rounded">
            <h4><b>{{d.name}}</b></h4>
            <h4>{{d.value}}</h4>
          </div>
        </div>
      </div>
     </div>
